import React, { useEffect, useState } from "react";
import { agentApi } from "../services/agentApi";
import PlaybookIdentityForm from "../components/agent/PlaybookIdentityForm";
import PlaybookStepsEditor from "../components/agent/PlaybookStepsEditor";
import PlaybookHoursEditor from "../components/agent/PlaybookHoursEditor";
import PlaybookFaqEditor from "../components/agent/PlaybookFaqEditor";
import PlaybookFollowUpEditor from "../components/agent/PlaybookFollowUpEditor";

const TABS = [
  { id: "identity", label: "Identidade" },
  { id: "steps", label: "Steps" },
  { id: "hours", label: "Janela horária" },
  { id: "followup", label: "Retentativa" },
  { id: "faq", label: "FAQ" },
];

export default function AgentPlaybook({ noPadding = false, readOnly = false }) {
  const [activePlaybook, setActivePlaybook] = useState(null);
  const [agentName, setAgentName] = useState("Marina");
  const [tab, setTab] = useState("identity");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  async function load() {
    setLoading(true);
    try {
      const r = await agentApi.playbooks.list();
      const list = r.playbooks || [];
      const active = list.find((p) => p.isActive) || list[0];
      if (!active) {
        setError("Nenhum playbook encontrado. Rode o seed primeiro.");
        return;
      }
      const detail = await agentApi.playbooks.get(active.id);
      setActivePlaybook(detail.playbook);
      if (detail.agentName) setAgentName(detail.agentName);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => { load(); }, []);

  if (loading) return <div className="p-6 text-gray-500">Carregando...</div>;
  if (error) return <div className="p-6 text-red-600">{error}</div>;
  if (!activePlaybook) return null;

  return (
    <div className={noPadding ? "" : "p-6 bg-gray-50 min-h-screen"}>
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-5 mb-4">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-semibold text-gray-900">{activePlaybook.name}</h1>
            <div className="text-sm text-gray-500 mt-1 flex items-center gap-2">
              <span>v{activePlaybook.version}</span>
              {activePlaybook.isActive && (
                <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-emerald-100 text-emerald-700">
                  ATIVO
                </span>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="bg-white rounded-lg shadow-sm border border-gray-200">
        <div className="border-b border-gray-200 px-4">
          <div className="flex gap-1">
            {TABS.map((t) => (
              <button
                key={t.id}
                onClick={() => setTab(t.id)}
                className={`px-4 py-3 text-sm border-b-2 transition-colors ${
                  tab === t.id
                    ? "border-blue-500 text-blue-600 font-medium"
                    : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                }`}
              >
                {t.label}
              </button>
            ))}
          </div>
        </div>

        <div className="p-5">
          {readOnly && (
            <div className="mb-4 rounded-lg border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-900">
              Modo somente leitura: você pode visualizar o playbook e expandir os steps, mas não pode alterar dados.
            </div>
          )}
          {tab === "identity" && (
            <PlaybookIdentityForm
              playbook={activePlaybook}
              agentName={agentName}
              onSaved={load}
              readOnly={readOnly}
            />
          )}
          {tab === "steps" && <PlaybookStepsEditor playbookId={activePlaybook.id} readOnly={readOnly} />}
          {tab === "hours" && <PlaybookHoursEditor playbook={activePlaybook} readOnly={readOnly} />}
          {tab === "followup" && (
            <PlaybookFollowUpEditor playbook={activePlaybook} onSaved={load} readOnly={readOnly} />
          )}
          {tab === "faq" && <PlaybookFaqEditor playbook={activePlaybook} readOnly={readOnly} />}
        </div>
      </div>
    </div>
  );
}
